import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { components } from 'react-select';

import './styles.scss';
import Select from '../../Select';

const RDStationSubmitLeadSettings = (props) => {
  const { item } = props;
  const items = useSelector((state) => state?.items?.allItems);

  const [conversionIdentifier, setConversionIdentifier] = useState('');
  const [selectedEscape, setSelectedEscape] = useState('');

  useEffect(() => {
    if (item && item?.rdStationSubmitLead) {
      const { conditionEscape, rdStationSubmitLead } = item;
      const { conversionIdentifier: currentConvIden } = rdStationSubmitLead;

      if (currentConvIden && currentConvIden !== '') {
        setConversionIdentifier(currentConvIden);
      } else {
        setConversionIdentifier('');
      }

      if (conditionEscape && conditionEscape !== '' && Array.isArray(items)) {
        const selectedEscapeItem = items.find(
          ({ _id }) => _id.toString() === conditionEscape
        );
        if (selectedEscapeItem) {
          setSelectedEscape({
            value: conditionEscape,
            label: selectedEscapeItem.title,
          });
        }
      }
    }
  }, [item, items]);

  const onChangeConversionIdentifier = useCallback(
    (event) => {
      const { doUpdateItem } = props;
      const { value } = event.target;
      const newRdStationSubmitLead = {
        ...item.rdStationSubmitLead,
        conversionIdentifier: value,
      };

      setConversionIdentifier(value);
      doUpdateItem({ rdStationSubmitLead: newRdStationSubmitLead });
    },
    [conversionIdentifier]
  );

  const onChangeEscapeSelect = useCallback(
    (option) => {
      const { doUpdateItem } = props;
      if (!option) {
        setSelectedEscape('');
        doUpdateItem({ conditionEscape: '' });
        return;
      }

      const newEscape = items.find(
        ({ _id }) => _id.toString() === option?.value
      );

      if (!newEscape) {
        setSelectedEscape('');
        doUpdateItem({ conditionEscape: '' });
        return;
      }

      setSelectedEscape(option);
      doUpdateItem({ conditionEscape: newEscape._id });
    },
    [items]
  );

  const escapeOptions = useMemo(() => {
    if (!item || !Array.isArray(items)) {
      return [];
    }

    return items
      .filter(({ _id }) => _id.toString() !== item._id.toString())
      .map(({ _id, title }) => ({
        value: _id,
        label: title,
      }));
  }, [items]);

  const optionEscape = (optionProps) => {
    const { data } = optionProps;
    return (
      <components.Option {...optionProps}>
        <strong>{data.label}</strong>
        <br />
        <span>{data.value}</span>
      </components.Option>
    );
  };

  return (
    <div>
      <div className="rd-station-input-settings-options-divider" />
      <div className="common-form-group">
        <label>Identificador de conversão</label>
        <input
          className="form-control mt-1"
          type="text"
          maxLength={60}
          value={conversionIdentifier || ''}
          onChange={onChangeConversionIdentifier}
        />
      </div>
      <div style={{ marginTop: 5 }}>
        <Select
          className="pt-0 mb-2"
          label="Escape"
          options={escapeOptions}
          value={selectedEscape}
          onChange={onChangeEscapeSelect}
          isClearable
          components={{ Option: optionEscape }}
        />
      </div>
    </div>
  );
};

export default RDStationSubmitLeadSettings;
